import {defineStore, type StoreDefinition} from "pinia";
import {type LoadingStoreState, state} from "@/store/loading/state";
import {actions, type LoadingStoreActions} from "@/store/loading/actions";

export type LoadingStoreType = StoreDefinition<string, LoadingStoreState, any, LoadingStoreActions>;

export const useLoadingStore: LoadingStoreType = defineStore('loadingStore', {
    state,
    actions
});
